module.exports = __webpack_public_path__ + "img/w3.4cbb3f74.png";